<template>
  <div>
    <!-- 城市仓主体认证弹窗 -->
    <el-dialog
      :title="`城市仓${titles}`"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          class="demo-cityForm"
          label-width="100px"
          ref="refCityForm"
          :model="cityForm"
          :rules="cityRules"
        >
          <el-form-item label="城市仓名称" prop="name">
            <el-input
              v-model="cityForm.name"
              :disabled="true"
              placeholder="请输入城市仓名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="主体性质" prop="certification_type">
            <el-radio-group v-model="cityForm.certification_type" :disabled="disabled">
              <el-radio :label="10">个人</el-radio>
              <el-radio :label="20">个体工商户</el-radio>
              <el-radio :label="30">企业</el-radio>
            </el-radio-group>
          </el-form-item>

          <div v-if="cityForm.certification_type != 10">
            <el-form-item label="营业执照" prop="license_img">
              <el-upload
                :action="httpurl"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: license_img.length || !license_img }"
                :file-list="license_img"
                :headers="{ token: token }"
                list-type="picture-card"
                :on-success="onsuccess"
                :before-remove="() => onHandleDeleteFile('license_img')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="主体名称" prop="register_name">
              <el-input
                v-model="cityForm.register_name"
                placeholder="请输入主体名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="uscc">
              <el-input
                v-model="cityForm.uscc"
                placeholder="请输入统一社会信用代码"
                clearable
              ></el-input>
            </el-form-item>
          </div>

          <div style="display: flex">
            <el-form-item label="持卡人身份证国徽页图片" prop="id_card_a_img">
              <el-upload
                action="#"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: id_card_a_img.length || !id_card_a_img }"
                :file-list="id_card_a_img"
                list-type="picture-card"
                :http-request="
                  (data) => onHandleUploadFile(data, 'id_card_a_img')
                "
                :before-remove="() => onHandleDeleteFile('id_card_a_img')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="持卡人身份证人像页图片" prop="id_card_b_img">
              <el-upload
                action="#"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: id_card_b_img.length || !id_card_b_img }"
                :file-list="id_card_b_img"
                list-type="picture-card"
                :http-request="
                  (data) => onHandleUploadFile(data, 'id_card_b_img')
                "
                :before-remove="() => onHandleDeleteFile('id_card_b_img')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </div>
          <div v-if="cityForm.certification_type == 10">
            <el-form-item label="姓名" prop="manage_name">
              <el-input
                v-model="cityForm.manage_name"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="id_card_code">
              <el-input
                v-model="cityForm.id_card_code"
                placeholder="请输入身份证号码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="manage_mobile">
              <el-input
                v-model="cityForm.manage_mobile"
                placeholder="请输入电话"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="cityForm.certification_type != 10">
            <el-form-item label="法人姓名" prop="manage_name">
              <el-input
                v-model="cityForm.manage_name"
                placeholder="请输入法人姓名"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="id_card_code">
              <el-input
                v-model="cityForm.id_card_code"
                placeholder="请输入身份证号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="法人电话" prop="manage_mobile">
              <el-input
                v-model="cityForm.manage_mobile"
                placeholder="请输入法人电话"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="onHandleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import {
  certifylogistics,
  postGetIdcardInfo,
  certifydetails,
} from "@/api/general/manager.js";

export default {
  name: "changeCardholderDialog",
  props: {
    /**
     * 银行列表
     */
    bankList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      token: sessionStorage.getItem("token"),
      httpurl: process.env.VUE_APP_GENERAL_URL + "/uploadBusinessLicense",
      dialogVisible: false,
      dialogLoading: false,
      title: "", // 城市仓名称
      titles: "", // 城市仓名称
      loadImage: null,
      depositLoading: false,
      depositList: [], // 开户行列表
      id_card_a_img: [], // 身份证国徽图片
      id_card_b_img: [], // 身份证人像图片
      license_img: [], // 变更协议
      // 城市仓参数
      cityForm: {
        name: "",
        logistics_id: "", //	T文本	是
        certification_type: 10, //	T文本	是	10 个人  20  个体  30 企业
        id_card_a_img: "", //	T文本	是身份证国徽图片
        id_card_b_img: "", //	T文本	是身份证人像图片
        id_card_code: "", //	T文本	是身份证号
        manage_name: "", //	T文本	是	姓名
        manage_mobile: "", //	T文本	是	电话
        uscc: "", //	T文本	是社会统一信用代码
        license_img: "", //	T文本	否	营业执照（个体，企业必填）
        register_name: "", //	T文本	否	主体名称（个体，企业必填）
        license_info: "", //	T文本	否	返回的营业执照信息（个体，企业必填）（类型：数组）
      },
      cityFormClone: {}, // 拷贝一份数据，用于初始化

      uploadLoading: false, // 上传loading
      submitLoading: false, // 提交按钮禁用
disabled:false,
      // 表单校验
      cityRules: {
        id_card_a_img: [
          {
            required: true,
            message: "请上传身份证国徽页图片",
            trigger: ["blur", "change"],
          },
        ],
        id_card_b_img: [
          {
            required: true,
            message: "请上传身份证人像页图片",
            trigger: ["blur", "change"],
          },
        ],
        license_img: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: ["blur", "change"],
          },
        ],
        certification_type: [
          {
            required: true,
            message: "请选择主体性质",
            trigger: ["blur", "change"],
          },
        ],

        manage_mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          // 正则判断为字母或数字
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],

        manage_name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],

        id_card_code: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
        ],
        uscc: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: ["blur", "change"],
          },
        ],
        register_name: [
          {
            required: true,
            message: "请输入主体名称",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 初始化
     */
    onInitData(data,title) {
      console.log(data, "data===");
      this.titles=title;
      this.disabled=false;
      //   this.cityForm.name=data.name;
      this.cityForm.logistics_id = data.id;
       this.id_card_a_img=[];
       this.id_card_b_img=[];
       this.license_img = [];
      certifydetails({
        logistics_id: this.cityForm.logistics_id,
      }).then((res) => {
        console.log(res, "1111");
         this.dialogVisible = true;
         if(res.data.certification_type==30){
            this.disabled=true;
         }
        if (res.data.id_card_a_img) {
          this.id_card_a_img = [
            {
              url: res.data.id_card_a_img,
              uid: 1,
            },
          ];
        }else{
             this.id_card_a_img=[]
        }
        if (res.data.id_card_b_img) {
          this.id_card_b_img = [
            {
              url: res.data.id_card_b_img,
              uid: 1,
            },
          ];
        }else{
             this.id_card_b_img=[]
        }
        if (res.data.license_img) {
          this.license_img = [
            {
              url: res.data.license_img,
              uid: 1,
            },
          ];
        }else{
           this.license_img = [] 
        }

        this.cityForm = res.data;
        this.cityFormClone = cloneDeep(this.cityForm);
      });

      // this.cityFormClone = cloneDeep(this.cityForm);
      //   this.$refs.refCityForm?.clearValidate();

      //   this.title = data.name; // 城市仓名称
      //   const {
      //     card_code,
      //     bank_code,
      //     bank_name,
      //     deposit_code,
      //     bank_deposit,
      //     idcard_name,
      //     mobile,
      //     idcard_code,
      //     idcard_a,
      //     idcard_b,
      //   } = JSON.parse(JSON.stringify(data.logistics_bank));

      //   const baseParams = {
      //     card_code,
      //     bank_code,
      //     bank_name,
      //     deposit_code,
      //     bank_deposit,
      //     idcard_name,
      //     idcard_a,
      //     idcard_b,
      //     idcard_code,
      //     bank_mobile: mobile,
      //     logistics_id: data.id,
      //   };

      //   Object.keys(this.cityForm).forEach((_KEY) => {
      //     this.cityForm[_KEY] = baseParams[_KEY];
      //   });

      //   this.idcard_a =
      //     (idcard_a && [
      //       {
      //         url: idcard_a,
      //       },
      //     ]) ||
      //     [];
      //   this.idcard_b =
      //     (idcard_b && [
      //       {
      //         url: idcard_b,
      //       },
      //     ]) ||
      //     [];
      //   this.cityForm.pact_url = "";
      //   console.log(this.cityForm, "this.cityForm==");
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.cityForm = {
        ...this.cityFormClone,
      };
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },
    /**
     * 获得开户行列表
     */
    async ajaxGetBranchList(query) {
      this.depositList = [];
      if (!query) {
        return;
      }
      this.depositLoading = true;
      const params = {
        bank_code: this.cityForm.bank_code,
        branch_name: query,
      };
      try {
        const { data } = await this.$api.general.branchList(params);
        this.depositList = data;
      } catch (err) {
        console.log("ajax branchList err", err);
      } finally {
        this.depositLoading = false;
      }
    },
    onsuccess(res) {
      console.log(res, "11111");
      if (res.msg) {
        this.$message({
          message: res.msg,
          type: "error",
        });
        return;
      }
      this.license_img = [{ url: res.data.file, uid: 1 }];
      this.cityForm.uscc = res.data.license_info.reg_num;
      this.cityForm.register_name = res.data.license_info.name;
      this.cityForm.license_img = res.data.file;
      this.cityForm.license_info = res.data.license_info;
    },
    /**
     * 删除图片
     */
    onHandleDeleteFile(name) {
      this[name] = [];
      this.cityForm[name] = "";
      this.$refs.refCityForm.validateField(name);
    },
    /**
     * 上传图片
     */
    onHandleUploadFile(options, name) {
      this.uploadLoading = true;
      // 拿到 file
      let file = options.file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // console.log(e.target.result);
        this.ajaxUploadImage(e.target.result, name, options.file.uid);
      };
    },
    /**
     * 图片路径请求
     */
    async ajaxUploadImage(img, name, uid) {
      try {
        const res = await this.$api.general.uploadImage({ file_data: img });
        // 增加uid 赋值 解决上传图片跳动问题
        this[name] = [{ url: res.data, uid }];
        this.cityForm[name] = res.data;
        if (name == "id_card_b_img") {
          this.postAjaxGetIdcardInfo(res.data); // 人像页ocr 识别
        }
        if (name == "license_img") {
          this.postAjaxGetlicense_imgInfo(res.data); // 人像页ocr 识别
        }
        this.$refs.refCityForm.validateField(name);
      } catch (err) {
      } finally {
        this.uploadLoading = false;
      }
    },
    // 身份证人像页上传ocr 识别身份证号
    async postAjaxGetIdcardInfo(url) {
      try {
        const res = await postGetIdcardInfo({ image_url: url });
        this.cityForm.id_card_code = res.data.idcard_code;
        this.cityForm.manage_name = res.data.idcard_name;
        console.log(res, res.data.idcard_code, this.cityForm, "res==");
      } catch (error) {
        console.log(error, "postGetIdcardInfo");
      }
    },
    /**
     * 预览上传图片
     */
    onHandlePictureCardPreview(file) {
      const params = {
        bigImage: file.url,
        showImage: true,
      };
      this.$emit("on-show-image", params);
    },

    /**
     * 确认
     */
    onHandleSubmit() {
      console.log(this.cityForm, "this.cityForm==");
      this.$refs.refCityForm.validate(async (valid) => {
        console.log(valid, "1valid11");
        if (!valid) {
          return;
        }
        let obj = JSON.parse(JSON.stringify(this.cityForm));
        if (this.cityForm.certification_type == 10) {
          delete obj.license_img;
          delete obj.register_name;
          delete obj.uscc;
        }
        this.submitLoading = true;
        try {
          const res = await certifylogistics(obj);
          console.log(res, "res==");

          this.dialogVisible = false;
          this.$message({
            message: "城市仓主体认证成功",
            type: "success",
          });
          this.$emit("on-refresh-list");
        } catch (error) {
          console.log(error, "certifylogistics");
        } finally {
          this.submitLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hide {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>
